<script setup>
import ContentHeader from "@/components/Dashboard/ContentHeader.vue";
import ContentCentralSection from "@/components/Dashboard/Users/Central/ContentCentralSection.vue";
</script>

<template>
  <ContentHeader :name="'Central Users'" />
  <ContentCentralSection />
</template>
